







































import { Component, Vue } from 'vue-property-decorator'
import { BForm, BFormRow, BCol, BFormGroup, BFormInput, BFormSelect, BButton, BIconSearch, BIconArrowCounterclockwise, BFormSelectOption } from 'bootstrap-vue';
import UserFilterOptions from '@/types/UserFilterOptions'
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

@Component({
    components: {
        'b-form': BForm,
        'b-form-row': BFormRow,
        'b-col': BCol,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-btn': BButton,
        'b-icon-search': BIconSearch,
        'b-icon-arrow-counterclockwise': BIconArrowCounterclockwise
    }
})
export default class UserFilter extends Vue {
    projects: ProjectFilterItem[] = [];
    apiAccessToken = this.$store.state.apiAccessToken;

    userStatuses: UserStatus[] = [
        { value: true, text: 'userStatus.yes' },
        { value: false, text: 'userStatus.no' }
    ]

    filter: UserFilterOptions = {
        sequenceOrName: null,
        isActive: true,
        projectId: null
    }

    mounted() {
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadProjects();
    }

    filterList(resetFilter: boolean) {
        if (resetFilter) {
            this.filter.sequenceOrName = null;
            this.filter.isActive = true;
            this.filter.projectId = null;
        }
        this.$emit('filter-list', this.filter);
    }

    async loadProjects() {
        try {
            const response = await AxiosService.request<EntityList>({
                url: `projectslookup`,
                method: 'GET'
            });

            this.projects = response.data.records ?? [];
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.$emit('load-complete');
        }
    }
}

interface EntityList {
    records: ProjectFilterItem[];
}

interface ProjectFilterItem {
    id: string;
    name: string;
    projectManagerId: string;
}

interface UserStatus {
    value: boolean | null;
    text: string;
} 
